import dynamic from "next/dynamic";
const App = dynamic(() => import("../../../components/App"));
import Head from "next/head";
import { useRouter } from "next/router";
import { Breadcrumb, Row, Col } from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Link from "next/link";

const ComponentEn = dynamic(() => import("./en"), {
  ssr: false,
});
const ComponentTh = dynamic(() => import("./th"), {
  ssr: false,
});

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const router = useRouter();
  const { locale } = router;
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const { t } = useTranslation("common");

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Product exchange return policy</title>
      </Head>
      <Row justify="center" className="mt-5 mb-5">
        <Col xs={22} sm={22} md={22} lg={22} xl={20}>
          <Breadcrumb
            items={[
              {
                key: "home",
                title: (
                  <Link href={`/${queryParam ? `?${queryParam}` : ``}`}>
                    {t("home")}
                  </Link>
                ),
              },
              {
                key: "terms-service-return",
                title: `${t("terms-service-return")}`,
              },
            ]}
          />
          {locale == "th" ? <ComponentTh /> : <ComponentEn />}
        </Col>
      </Row>
    </App>
  );
};

export default Home;
